import { atom } from "recoil";

// export const itineraryState = atom<ConferenceSchedule>({
export const itineraryState = atom<any>({
  key: "emptyApiResponse",
  default: {
    dates: [],
  },
});
